import React from 'react';
import Pagination from "react-js-pagination";
import StyledPagination from './Styled/Pagination';

export default props => (
  <StyledPagination>
    <Pagination {...props} />
  </StyledPagination>
);
